(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Flash-once header background: 0.6s on first scroll past header;
  // then hide the inner header until user returns to top.
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      // Flash state
      this.bgShownOnce = false;
      this.bgTimeout = null;

      // 🔎 Robust target for the inner header to hide/show
      this.innerHeader =
        this.querySelector('header.header.header--middle-center.header--mobile-center.page-width.header--has-menu.header--has-account') ||
        this.querySelector('header.header') ||
        this.querySelector('header');

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('amumin-sticky-active');
        this.classList.remove('amumin-sticky-active');
        this.header.classList.remove('shopify-section-header-hidden', 'scrolled-past-header');
        if (this.innerHeader) this.innerHeader.classList.remove('header--flash-hidden');
      }

      this.isAmuminStickyActive = false;
      this.amuminStickyEnterOffset = 24;
      this.amuminStickyExitOffset = 10;
      this.amuminShrinkRange = 640;
      this.style.setProperty('--amumin-scroll-progress', '0');
      this.header.style.setProperty('--amumin-scroll-progress', '0');

      this.currentScrollTop = 0;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.bgTimeout) clearTimeout(this.bgTimeout);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // AMUMIN sticky-always guard: keep header permanently visible
      if (this.headerIsAlwaysSticky) {
        const shrinkRange = this.amuminShrinkRange || 640;
        const shrinkProgress = Math.max(0, Math.min(scrollTop / shrinkRange, 1));
        this.style.setProperty('--amumin-scroll-progress', shrinkProgress.toFixed(4));
        this.header.style.setProperty('--amumin-scroll-progress', shrinkProgress.toFixed(4));

        const shouldActivateSticky = this.isAmuminStickyActive
          ? scrollTop > this.amuminStickyExitOffset
          : scrollTop > this.amuminStickyEnterOffset;
        this.isAmuminStickyActive = shouldActivateSticky;
        const isStickyActive = this.isAmuminStickyActive;
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.toggle('amumin-sticky-active', isStickyActive);
        this.classList.toggle('amumin-sticky-active', isStickyActive);
        this.header.classList.remove('shopify-section-header-hidden', 'scrolled-past-header');
        if (this.innerHeader) this.innerHeader.classList.remove('header--flash-hidden');
        this.currentScrollTop = scrollTop;
        return;
      }

      // Show flash only once per scroll session, then hide inner header
      if (scrollTop > this.headerBounds.bottom) {
        // if we've already flashed once, ensure it stays hidden while down
        if (this.bgShownOnce && this.innerHeader) {
          this.innerHeader.classList.add('header--flash-hidden');
        }

        if (!this.bgShownOnce && !this.bgTimeout) {
          this.header.classList.add('scrolled-past-header');

          this.bgTimeout = setTimeout(() => {
            this.header.classList.remove('scrolled-past-header');
            if (this.innerHeader) this.innerHeader.classList.add('header--flash-hidden'); // HIDE after flash
            this.bgShownOnce = true;
            this.bgTimeout = null;
          }, 600); // 0.6s
        }
      } else {
        // Back near the top — reset allowance and show header again
        if (this.bgTimeout) {
          clearTimeout(this.bgTimeout);
          this.bgTimeout = null;
        }
        this.header.classList.remove('scrolled-past-header');
        if (this.innerHeader) this.innerHeader.classList.remove('header--flash-hidden'); // SHOW
        this.bgShownOnce = false;
      }

      this.currentScrollTop = scrollTop;
    }

    reveal() {
      this.header.classList.remove('shopify-section-header-hidden', 'scrolled-past-header');
      if (this.innerHeader) this.innerHeader.classList.remove('header--flash-hidden');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
